module.exports = __webpack_public_path__ + "img/percent.fd415af1.svg";